<template>
  <el-dialog
    :title="$t('affiliateRuleManage.edit')"
    :visible.sync="dialogVisible"
    width="50%"
    @close="handleClose"
  >
    <el-form
      :model="editAffiliateRuleInfo"
      :rules="rules"
      ref="editForm"
      label-width="150px"
    >
      <el-form-item
        :label="$t('affiliateRuleManage.ruleName')"
        prop="name"
      >
        <el-input
          v-model="editAffiliateRuleInfo.name"
          :placeholder="$t('affiliateRuleManage.ruleNamePlaceholder')"
        ></el-input>
      </el-form-item>
      <el-form-item
        :label="$t('affiliateRuleManage.level1Rate')"
        prop="level1Rate"
      >
        <el-input
          v-model="editAffiliateRuleInfo.level1Rate"
          :placeholder="$t('affiliateRuleManage.level1RatePlaceholder')"
        ></el-input>
      </el-form-item>
      <el-form-item
        :label="$t('affiliateRuleManage.level2Rate')"
        prop="level2Rate"
      >
        <el-input
          v-model="editAffiliateRuleInfo.level2Rate"
          :placeholder="$t('affiliateRuleManage.level2RatePlaceholder')"
        ></el-input>
      </el-form-item>
      <el-form-item
        :label="$t('affiliateRuleManage.level21Rate')"
        prop="level21Rate"
      >
        <el-input
          v-model="editAffiliateRuleInfo.level21Rate"
          :placeholder="$t('affiliateRuleManage.level21RatePlaceholder')"
        ></el-input>
      </el-form-item>
      <el-form-item
        :label="$t('affiliateRuleManage.expireDay')"
        prop="expireDay"
      >
        <el-input
          v-model="editAffiliateRuleInfo.expireDay"
          :placeholder="$t('affiliateRuleManage.expireDayPlaceholder')"
        ></el-input>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">
        {{ $t('common.cancel') }}
      </el-button>
      <el-button type="primary" @click="editAffiliateRule">
        {{ $t('common.save') }}
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
import { updateAffiliateRule } from '@/api/affiliate/affiliateRuleApi'
import { getShopId } from '@/api/shop/shopApi'

export default {
  name: 'EditAffiliateRule',
  data() {
    return {
      dialogVisible: false,
      editAffiliateRuleInfo: {
        ruleId: '',
        name: '',
        level1Rate: '',
        level2Rate: '',
        level21Rate: '',
        expireDay: '',
        shopId: ''
      },
      rules: {
        name: [
          { required: true, message: this.$t('affiliateRuleManage.ruleNameRequired'), trigger: 'blur' },
          { max: 30, message: this.$t('affiliateRuleManage.ruleNameMaxLength'), trigger: 'blur' }
        ],
        level1Rate: [
          { required: true, message: this.$t('affiliateRuleManage.level1RateRequired'), trigger: 'blur' },
          { max: 32, message: this.$t('affiliateRuleManage.level1RateMaxLength'), trigger: 'blur' }
        ],
        expireDay: [
          { required: true, message: this.$t('affiliateRuleManage.expireDayRequired'), trigger: 'blur' },
          { max: 200, message: this.$t('affiliateRuleManage.expireDayMaxLength'), trigger: 'blur' }
        ],
        ruleId: [
          { required: true, message: this.$t('affiliateRuleManage.ruleIdRequired'), trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    open(row) {
      this.dialogVisible = true
      this.editAffiliateRuleInfo = { ...row }
      this.editAffiliateRuleInfo.shopId = getShopId()
    },
    handleClose() {
      this.$refs.editForm.resetFields()
    },
    editAffiliateRule() {
      this.$refs.editForm.validate(async valid => {
        if (valid) {
          try {
            await updateAffiliateRule(this.editAffiliateRuleInfo)
            this.$message.success(this.$t('affiliateRuleManage.updateSuccess'))
            this.dialogVisible = false
            this.$emit('refresh')
          } catch (error) {
            console.error(error)
          }
        }
      })
    }
  }
}
</script>